import { getData } from '@portal-internet/bff';
import { useUser } from '../../hooks/useUser';
import __get from 'lodash/get';
import __isEmpty from 'lodash/isEmpty';
import { createContext, useState, useMemo } from 'react';
import useIsServiceEnabled from '../../hooks/useIsServiceEnabled';

const urlBase = 'https://api.3cat.cat';
export const ContentUserContext = createContext();

const ContentUserProvider = (props) => {
    const { children } = props;
    const { isAuthenticated, accessToken } = useUser();
    const isVrEnabled = useIsServiceEnabled('videos-recomanats');
    const isRmEnabled = useIsServiceEnabled('resume-media');
    const isSpmEnabled = isVrEnabled && isRmEnabled;
    const [itemsSubscripcionsButlletins, setItemsSubscripcionsButlletins] = useState({ itemsLoaded: false, items: [] });

    const [isLoading, setIsLoading] = useState(false);

    const RESPOSTA_STATUS = 'resposta.status';
    const RESPOSTA_ITEMS_ITEM = 'resposta.items.item';

    const getSubscripcionsButlletins = async () => {
        if (!isAuthenticated || !accessToken || itemsSubscripcionsButlletins.itemsLoaded || !isSpmEnabled) return false;
        setIsLoading(true);
        const urlUserSubscripcions = `${urlBase}/usuaris/llistes/obtenircontinguts?_format=json&tipus_llista=newsletter&pagina=1&sdom=img&version=2.0&cache=30&redl=false&master=no&usuari_id=${accessToken}`;
        const rawData = await getData({
            queryKey: ['itemsSubscripcionsButlletins', { url: urlUserSubscripcions, fetchFromOrigin: true }]
        });
        const isStatusOk = __get(rawData, RESPOSTA_STATUS) === 'OK';
        const items = isStatusOk ? __get(rawData, RESPOSTA_ITEMS_ITEM) : [];
        setItemsSubscripcionsButlletins({ itemsLoaded: true, items });
        setIsLoading(false);
        return true;
    };

    const addSubscripcioButlleti = async (id) => {
        if (!isAuthenticated || !accessToken || !isSpmEnabled) return false;
        setIsLoading(true);
        const urlAddSubscripcio = `${urlBase}/usuaris/llistes/afegircontingut?_format=json&usuari_id=${accessToken}&tipologia=DTY_NEWSLETTER&contingut_id=${id}&tipus_llista=newsletter&version=2.0&sdom=img&master=yes`;
        const rawData = await getData({
            queryKey: ['addItemsSubscripcionsButlletins', { url: urlAddSubscripcio, fetchFromOrigin: true }]
        });
        const isStatusOk = __get(rawData, RESPOSTA_STATUS) === 'OK';
        if (isStatusOk)
            setItemsSubscripcionsButlletins((itemsButlletins) => ({
                itemsLoaded: true,
                items: [...itemsButlletins.items, { contingut_id: id, info_contingut: { id } }]
            }));
        setIsLoading(false);
        return isStatusOk;
    };

    const removeSubscripcioButlleti = async (id) => {
        if (!isAuthenticated || !accessToken || !isSpmEnabled) return false;
        setIsLoading(true);
        const urlRemoveSubscripcio = `${urlBase}/usuaris/llistes/esborrarcontingut?_format=json&contingut_id=${id}&tipologia=DTY_NEWSLETTER&tipus_llista=newsletter&usuari_id=${accessToken}&sdom=img&version=2.0&master=yes`;
        const rawData = await getData({
            queryKey: ['removeItemsSubscripcionsButlletins', { url: urlRemoveSubscripcio, fetchFromOrigin: true }]
        });
        const isStatusOk = __get(rawData, RESPOSTA_STATUS) === 'OK';
        if (isStatusOk)
            setItemsSubscripcionsButlletins((itemsButlletins) => ({
                itemsLoaded: true,
                items: itemsButlletins.items.filter((item) => item?.info_contingut?.id.toString() !== id.toString())
            }));
        setIsLoading(false);
        return isStatusOk;
    };

    const contextValue = useMemo(
        () => ({
            getSubscripcionsButlletins,
            addSubscripcioButlleti,
            removeSubscripcioButlleti,
            itemsSubscripcionsButlletins,
            isLoading
        }),
        [getSubscripcionsButlletins, addSubscripcioButlleti, removeSubscripcioButlleti, itemsSubscripcionsButlletins, isLoading]
    );

    return <ContentUserContext.Provider value={contextValue}>{children}</ContentUserContext.Provider>;
};

export default ContentUserProvider;
